import Navbar from "./navbar"
import Header from "./header";
//import Footer from './footer'


//import React from 'react'

//NOTA: usado en PrivateRoutes para menu solo de paginas privadas

export const LayoutPriv = ({ children }) => {
	return (
		<div className="h-dvh flex flex-col">
			<Header >
				<Navbar />
			</Header>
			<main className="flex-1 min-h-0 overflow-auto">
				{children}
			</main>
			{/* <Footer /> */}
		</div>
	)
}

